import useLocales from 'hooks/useLocales';
import React, { useEffect } from 'react';
import { IIndustry } from 'core/interface/companies';
import { getIndustryDisplayName } from 'utils/industry';

export const IndustryList = ({
  industry,
  industriesBtnRef,
  showIndustries,
  setShowIndustries
}: {
  industry: IIndustry[];
  showIndustries: boolean;
  industriesBtnRef: React.RefObject<HTMLSpanElement>;
  setShowIndustries: (show: boolean) => void;
}) => {
  const { t } = useLocales();
  const modalRef = React.useRef<HTMLDivElement>(null);
  const firstIndustry = industry[0];

  useEffect(() => {
    if (!showIndustries) return;
    function handleClickOutside(event: MouseEvent) {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target as Node) &&
        industriesBtnRef.current &&
        !industriesBtnRef.current.contains(event.target as Node)
      ) {
        setShowIndustries(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showIndustries, setShowIndustries, industriesBtnRef]);

  if (!firstIndustry) {
    return null;
  }

  return (
    <>
      <span className="IRCard__left__info_industry" key={firstIndustry.id}>
        {getIndustryDisplayName(firstIndustry)}
      </span>
      {industry.length > 1 && (
        <span
          ref={industriesBtnRef}
          className="IRCard__left__info_industry"
          style={{
            cursor: 'pointer'
          }}
          onClick={(e) => {
            e.stopPropagation();
            setShowIndustries(true);
          }}
        >
          + {industry.length - 1}
        </span>
      )}
      {showIndustries && (
        <div
          ref={modalRef}
          className="industry-modal"
          style={{
            position: 'absolute',
            top: 60,
            left: 0,
            zIndex: 100,
            background: '#fff',
            border: '1px solid #ccc',
            borderRadius: 8,
            boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
            padding: 12,
            minWidth: 180
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div style={{ fontWeight: 600, marginBottom: 8 }}>
            {t('Industries')}
          </div>
          <ul
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              margin: 0,
              padding: 0,
              gap: 8
            }}
          >
            {industry.map((el) => (
              <span className="IRCard__left__info_industry" key={el.id}>
                {getIndustryDisplayName(el)}
              </span>
            ))}
          </ul>
          <button
            style={{
              marginTop: 8,
              padding: '2px 10px',
              borderRadius: 4,
              border: 'none',
              background: '#eee',
              cursor: 'pointer',
              color: 'black'
            }}
            onClick={() => setShowIndustries(false)}
          >
            {t('Close')}
          </button>
        </div>
      )}
    </>
  );
};
